import { render, staticRenderFns } from "./add-to-board-dropdown.vue?vue&type=template&id=0055bdcb"
import script from "./add-to-board-dropdown.vue?vue&type=script&lang=js"
export * from "./add-to-board-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports